// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2b-0";